import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import LayerService from "../services/LayerService";

const useLayerService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new LayerService(client);
  }, [client]);

  return service;
};

export default useLayerService;
